const FALLBACK = "Something went wrong";

type ApiErrorLike = {
  data?: { message?: unknown; error?: { message?: unknown } };
};

export const readError = (error: unknown): string => {
  const data = (error as ApiErrorLike)?.data;

  if (typeof data?.error?.message === "string") return data.error.message;
  if (typeof data?.message === "string") return data.message;

  return FALLBACK;
};
